import { render, staticRenderFns } from "./com.vue?vue&type=template&id=312d0dbd&scoped=true&"
import script from "./com.vue?vue&type=script&lang=js&"
export * from "./com.vue?vue&type=script&lang=js&"
import style0 from "./com.vue?vue&type=style&index=0&id=312d0dbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d0dbd",
  null
  
)

export default component.exports